import { styled } from '@mui/material/styles';
import { useDrawingArea } from '@mui/x-charts/hooks';
import React from 'react';

const OverlayText = styled('text')(({ theme }) => ({
  ...theme.typography.body2,
  stroke: 'none',
  fill: theme.palette.text.secondary,
  shapeRendering: 'crispEdges',
  textAnchor: 'middle',
  dominantBaseline: 'middle',
}));

type Props = React.SVGAttributes<SVGTextElement> & {
  message: React.ReactNode;
};

const ChartHiddenSeriesOverlay: React.FC<Props> = ({ message, className, ...props }) => {
  const { left, top, width, height } = useDrawingArea();

  return (
    <OverlayText
      {...props}
      className={['chart-hidden-series-overlay-text', className].filter(Boolean).join(' ')}
      x={left + width / 2}
      y={top + height / 2}>
      {message}
    </OverlayText>
  );
};

export default ChartHiddenSeriesOverlay;
